<div class="card">
  <div class="card-body">
    <div class="card-title h5">
      <div class="row g-0 align-items-center">
        <div class="col-auto">
          <fa-icon class="text-info me-3" [icon]="faAnalytics" [fixedWidth]="true"></fa-icon>
        </div>
        <div class="col">Reports</div>
        <div *ngIf="allRoute" class="col-auto">
          <a class="btn btn-link border-0" [routerLink]="allRoute">
            All Reports<fa-icon class="text-primary ms-1" [icon]="faChevronRight" [fixedWidth]="true"></fa-icon>
          </a>
        </div>
      </div>
    </div>
    <div class="card-text">
      <dx-loss-run-button type="agency"></dx-loss-run-button>
    </div>
  </div>
</div>
